<template>
  <div class="mobFooter gray_9">
    <div class="bottom">
      <h5 class="line_h50">联系我们</h5>
      <p>联系电话：13671004684（同微信号）</p>
      <p>联系人：冯兴臣</p>
      <p>邮箱：fengxingchen@nxin.com</p>
      <p>公司地址：北京市海淀区中关村大街27号中关村大厦16层</p>
      <div class="box33"></div>
      <h5 class="line_h42">加入我们投递简历</h5>
      <p class="line_h42">邮箱：wangke@nxin.com</p>
      <div class="box24"></div>
      <div class="clear">
        <van-row>
          <van-col span="12">
            <h5 class="line_h46">关于我们</h5>
            <p @click="routerPush('/about')">公司介绍</p>
          </van-col>
          <van-col span="12">
            <h5 class="line_h46">关注我们</h5>
            <div class="pad10_t">
              <img class="inlineBlock mar20_r w150" :src="icon_tt" alt />
              <img class="inlineBlock mar20_r w150" :src="icon_wx" alt />
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="box25"></div>
    <div class="text-center">
      <p class="f10">
        Copyright © 2013-2021 农信互联版权所有 <span @click="activeClick('https://beian.miit.gov.cn')">京ICP备13013445号</span>
      </p>
      <p>京公网安备11010802000105</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      icon_tt: require('@/assets/lib/images/ewm_tt.png'),
      icon_wx: require('@/assets/lib/images/ewm_wx.png'),
    }
  },
  methods: {
    activeClick (url) {
      window.location.href = url
    },
    routerPush(path) {
      if (this.$route.path == path) return
      else {
        this.$router.push(path)
      }
    },
  },
}
</script>

<style lang="scss">
.mobFooter {
  padding: 0.32rem 0.3rem;
  background: #2e3033;

  .line_h42 {
    line-height: 0.42rem;
  }

  .line_h46 {
    line-height: 0.46rem;
  }
  .line_h50 {
    line-height: 0.5rem;
  }
  .box24 {
    height: 0.24rem;
  }
  .box25 {
    height: 0.25rem;
    margin-top: 0.4rem;
    border-top: 1px solid #3e4245;
  }
  .box33 {
    height: 0.33rem;
  }

  h5 {
    margin: 0;
    font-size: 0.24rem;
    font-weight: normal;
  }
  p {
    margin: 0;
    font-size: 0.2rem;
    line-height: 0.32rem;
  }
}
</style>
